// extracted by mini-css-extract-plugin
module.exports = {"selectedIndicator":"indicator_selectedIndicator__qnhBJ","normalIndicator":"indicator_normalIndicator__FpBXv"};